<template>
  <div class="fan fan-component">
    <!-- 签名显示区域 -->
    <div class="upesign">
      <!-- 有签名时显示图片和清除按钮 -->
      <div v-if="fileList.length > 0" class="signature-container">
        <img 
          style="width: 100px; height: auto; cursor: pointer" 
          :src="value" 
          @click="bindImgsPreview" 
          alt="签名预览"
        />
        <a-button 
          size="small" 
          type="text" 
          style="color: #f5222d; margin-left: 10px; cursor: pointer"
          @click="handleClearSignature"
          :disabled="sudisabled"
        >
          清除
        </a-button>
      </div>
      <!-- 无签名时显示签名按钮 -->
      <a-button 
        size="small" 
        v-else 
        :disabled="sudisabled" 
        @click="bindOpenEsign"  
        type="primary"
      >
        签名
      </a-button>
    </div>

    <!-- 图片预览弹窗 -->
    <a-modal 
      :visible="isPreview" 
      :footer="null" 
      @cancel="bindImgsPreviewCancle"
      title="签名预览"
    >
      <img style="width: 100%; max-width: 600px; margin: 0 auto; display: block" :src="previewImg" />
    </a-modal>

    <!-- 签名弹窗 -->
    <a-modal 
      title="请完成签名" 
      width="600px" 
      :visible="isSignModalVisible" 
      @cancel="closeSignModal"
      destroyOnClose
    >
      <vue-esign 
        ref="esign" 
        :width="600" 
        :height="200" 
        :lineWidth="esign.lineWidth" 
        :lineColor="esign.lineColor" 
        :bgColor.sync="esign.bgColor" 
      />
      <template #footer>
        <a-button key="back" @click="handleReset">清空面板</a-button>
        <a-button key="submit" type="primary" @click="handleGenerate">确认签名</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import vueEsign from 'vue-esign'

export default {
  name: 'FEsignBm',
  components: {
    vueEsign
  },
  props: {
    // 字段名（用于通知父组件更新对应字段）
    name: {
      type: String,
      required: true
    },
    // 父组件传入的签名Base64（修改时显示）
    value: {
      type: String,
      default: ''
    },
    // 是否禁用
    sudisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 用于显示签名的列表（适配UI展示）
      fileList: [],
      // 预览相关
      previewImg: '',
      isPreview: false,
      // 签名弹窗控制
      isSignModalVisible: false,
      // 签名配置
      esign: {
        lineWidth: 6,       // 线条宽度
        lineColor: '#000000', // 线条颜色
        bgColor: ''         // 背景色（透明）
      }
    }
  },
  watch: {
    // 监听父组件传入的value变化（如修改时重新赋值）
    value: {
      handler(newVal) {
        this.initSignature(newVal)
      },
      immediate: true // 初始化时立即执行
    }
  },
  methods: {
    /**
     * 初始化签名显示
     * @param {String} val - 签名Base64字符串
     */
    initSignature(val) {
      this.fileList = []
      // 验证是否为有效的Base64图片
      if (val && val.startsWith('data:image/')) {
        this.fileList = [{
          uid: 'signature_' + Date.now(),
          name: '签名图片',
          thumbUrl: val,
          status: 'done'
        }]
      }
    },

    /**
     * 打开签名弹窗
     */
    bindOpenEsign() {
      // 打开前重置画布（避免残留旧签名）
      if (this.$refs.esign) {
        this.$refs.esign.reset()
      }
      this.isSignModalVisible = true
    },

    /**
     * 关闭签名弹窗
     */
    closeSignModal() {
      this.isSignModalVisible = false
    },

    /**
     * 预览签名图片
     */
    bindImgsPreview() {
      this.previewImg = this.value
      this.isPreview = true
    },

    /**
     * 关闭预览弹窗
     */
    bindImgsPreviewCancle() {
      this.previewImg = ''
      this.isPreview = false
    },

    /**
     * 清空签名面板
     */
    handleReset() {
      if (this.$refs.esign) {
        this.$refs.esign.reset()
      }
    },

    /**
     * 清除现有签名
     */
    handleClearSignature() {
      // 1. 清空本地显示
      this.fileList = []
      // 2. 通知父组件清除数据
      this.$emit('change', this.name, '')
      // 3. 重置画布（防止重签时残留）
      if (this.$refs.esign) {
        this.$refs.esign.reset()
      }
    },

    /**
     * 生成签名并验证
     */
    handleGenerate() {
      this.$refs.esign.generate().then(base64Str => {
        // 1. 验证格式（PNG/JPEG）
        const isPNG = base64Str.startsWith('data:image/png;base64,')
        const isJPEG = base64Str.startsWith('data:image/jpeg;base64,') || 
                      base64Str.startsWith('data:image/jpg;base64,')
        if (!isPNG && !isJPEG) {
          this.$message.error('签名格式错误，请使用PNG或JPEG格式')
          return
        }

        // 2. 验证大小（不超过2M）
        const base64Data = base64Str.split(',')[1] // 移除前缀
        const padding = base64Data.endsWith('==') ? 2 : base64Data.endsWith('=') ? 1 : 0
        const fileSizeBytes = (base64Data.length * 3 / 4) - padding // Base64转字节数
        const maxSizeBytes = 2 * 1024 * 1024 // 2M

        if (fileSizeBytes > maxSizeBytes) {
          this.$message.error('签名大小不能超过2M')
          return
        }

        // 3. 验证通过，更新数据
        this.fileList = [{
          uid: 'signature_' + Date.now(),
          name: '签名图片',
          thumbUrl: base64Str,
          status: 'done'
        }]
        // 通知父组件更新数据（覆盖旧值）
        this.$emit('change', this.name, base64Str)
        this.closeSignModal()
        this.$message.success('签名成功')
      }).catch(err => {
        this.$message.warning('请先在面板上完成签名')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.upesign {
  .signature-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}

/* 弹窗图片自适应 */
::v-deep .ant-modal-body {
  padding: 20px;
  text-align: center;
}
</style>
